import { render } from "./FittedMarginTitle.vue?vue&type=template&id=321caf1a&scoped=true"
import script from "./FittedMarginTitle.vue?vue&type=script&lang=js"
export * from "./FittedMarginTitle.vue?vue&type=script&lang=js"

import "./FittedMarginTitle.vue?vue&type=style&index=0&id=321caf1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321caf1a"]])

export default __exports__